import React from 'react';
import HeroScrollIndicator from './HeroScrollIndicator';
import HeroTitle from './HeroTitle';
import styles from './onboardingHero.module.css';

interface HeroContentProps {
  titleLineOne: string;
  titleLineTwo: string;
}

const HeroContent: React.FC<HeroContentProps> = ({ titleLineOne, titleLineTwo }) => (
  <div className={styles.content}>
    <HeroTitle lineOne={titleLineOne} lineTwo={titleLineTwo} />
    <HeroScrollIndicator />
  </div>
);

export default HeroContent;
